/* eslint-disable no-console */
import { startPerfSpan, verboseLogPerfSpanEnd } from './userExtAnalytics/bugsnag';

const PERF_LOG_STYLE_FAST = 'color: #999; font-weight: 500';
const PERF_LOG_STYLE_NORMAL = 'color: #0d7d7d; font-weight: 600';
const PERF_LOG_STYLE_SLOW = 'color: #e67e00; font-weight: 600';
const PERF_LOG_STYLE_VERY_SLOW = 'color: #c0392b; font-weight: 600';

function perfLogStyle(sec) {
  if (sec >= 1) return PERF_LOG_STYLE_VERY_SLOW;
  if (sec >= 0.5) return PERF_LOG_STYLE_SLOW;
  if (sec >= 0.1) return PERF_LOG_STYLE_NORMAL;

  return PERF_LOG_STYLE_FAST;
}

function isErrorLike(val) {
  return val instanceof Error || (typeof val === 'object' && val !== null && (val.message != null || val.stack != null));
}

const log = {
  error(a, b) {
    let descriptor = '';
    let err = null;

    if (b !== undefined && b !== null && isErrorLike(b)) {
      descriptor = typeof a === 'string' ? a : '';
      err = b;
    } else if (typeof a === 'string') {
      descriptor = a;
    } else if (a !== undefined && a !== null && isErrorLike(a)) {
      err = a;
    }
    if (descriptor) console.error(descriptor);
    if (err) console.error(err);
    if (err) {
      import('./userExtAnalytics/bugsnag').then(m => {
        if (typeof m.notifyErrorSafely === 'function') {
          m.notifyErrorSafely(err);
        }
      });
    }
  },
  time(spanName) {
    const t0 = performance.now();
    const span = typeof startPerfSpan === 'function' ? startPerfSpan(spanName) : null;

    return {
      end() {
        try {
          const secNum = (performance.now() - t0) / 1000;
          const sec = secNum.toFixed(3);

          if (span) {
            if (span.setAttribute) span.setAttribute('perf.duration_sec', secNum);
            verboseLogPerfSpanEnd(spanName, Math.round(secNum * 1000));
            if (span.end) span.end();
          }
          console.log(`%c[perf] ${spanName}, ${sec}s`, perfLogStyle(secNum));
        } catch (e) {
          console.error('[log.time] end failed', spanName, e);
        }
      },
    };
  },
};

export default log;
export { log };
